import { render } from "./ApprovedRequests.vue?vue&type=template&id=9ac285ee"
import script from "./ApprovedRequests.vue?vue&type=script&lang=js"
export * from "./ApprovedRequests.vue?vue&type=script&lang=js"

import "./ApprovedRequests.vue?vue&type=style&index=0&id=9ac285ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__